<template>
  <div>
    <span v-if="name" style="font-size: 15px; font-weight: 600; padding-left: 2px;">{{ name }}</span>
    <table v-if="items.length > 0" style="font-size: 13px; width: 100%; margin: 4px 0;">
      <tr v-for="(item, index) in items" :key="`item ${index}`">
        <td style="width: 80%">{{ item.name }}</td>
        <td style="vertical-align: top;">
          {{ numberFormat({ number: item.amount, style: 'currency', currency: 'USD', notation: 'compact' }) }}
        </td>
      </tr>
    </table>

    <div style="text-align: center; margin: 8px 0;" v-else v-html="$t('leadWeekly.table.noData')" />
  </div>
</template>

<script>
import { numberFormat } from '@/utils/formatters.util'
export default {
  name: 'LpeReportArray',
  props: {
    items: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      numberFormat,
    }
  },
}
</script>
